import { apiRequest } from "../util/apiUtils";

export const recordShopifyCheckoutHandoff = async (bookIds) => {
  const res = await apiRequest("post", `book/shopify-checkout-handoff`, {
    body: { bookIds },
  });
  return res?.data;
};

/** Review order's Checkout didn't leave for Shopify in time; the API logs one [CHECKOUT-STALLED] line. */
export const recordShopifyCheckoutStalled = async ({ bookIds, waitedMs }) => {
  await apiRequest("post", `book/shopify-checkout-stalled`, {
    body: { bookIds, waitedMs },
  });
};

export const bookAdd = async (payload) => {
  try {
    const res = await apiRequest("post", `book/add`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const booksGet = async (queries) => {
  try {
    const res = await apiRequest("get", `book/list`, queries ? { queries } : undefined);

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const bookEdit = async (params) => {
  try {
    const res = await apiRequest("put", `book/edit`, {
      body: params
    })
    return res?.data
  } catch (err) {
    throw err
  }
}

export const reorderBooks = async (params) => {
  try {
    await apiRequest("patch", `media/ordering`, {
      body: params
    })
  } catch (err) {
    throw err
  }
}

export const removeBookImage = async (id) => {
  try {
    // apiRequest doesn't throw: this is undefined when the request never got an answer.
    return await apiRequest("delete", `media/delete/${id}`);
  } catch (err) {
    throw err;
  }
}

/** Soft-delete one of the customer's own books (the API checks ownership). */
export const bookDelete = async (id) => {
  try {
    return await apiRequest("patch", "book/delete", { body: { id } });
  } catch (error) {
    return error?.response?.data || { success: false, message: error?.message };
  }
};

/**
 * Switch an unordered book between a printed book and PDF only (`format`:
 * "print" | "pdf"). The API refuses ordered, gift and Etsy books (409).
 */
/** PDF downsell link: switch the last checkout's books to PDF only. Returns `{ success, data: { bookIds } }`. */
export const getPdfOffer = async () => {
  try {
    const res = await apiRequest("post", `book/pdf-offer`, { body: {} });
    return res?.data;
  } catch (err) {
    return { success: false };
  }
};

export const setBookFormat = async (id, format) => {
  try {
    const res = await apiRequest("put", `book/format`, { body: { id, format } });
    return res?.data;
  } catch (err) {
    return { success: false, message: err?.response?.data?.message || "We couldn't change that. Please try again." };
  }
};
